import React from 'react';
import { ErrorMessage, useField } from 'formik';

const onlyDigits = (v) => (v || '').replace(/\D/g, '');

export const formatPhone = (d) => {
  d = onlyDigits(d).slice(0, 10);
  if (!d) return '';
  if (d.length <= 3) return '(' + d;
  if (d.length <= 6) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
  return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6, 10);
};

export const formatSSN = (d) => {
  d = onlyDigits(d).slice(0, 9);
  if (!d) return '';
  if (d.length <= 3) return d;
  if (d.length <= 5) return d.slice(0, 3) + '-' + d.slice(3);
  return d.slice(0, 3) + '-' + d.slice(3, 5) + '-' + d.slice(5, 9);
};

const MaskedField = ({ label, placeholder, compulsory, name, maxDigits, formatter }) => {
  const [field, meta, helpers] = useField(name);
  const handleChange = (e) => {
    let digits = onlyDigits(e.target.value);
    if (maxDigits) digits = digits.slice(0, maxDigits);
    helpers.setValue(formatter ? formatter(digits) : digits);
  };
  return (
    <div className="mb-2">
      <label htmlFor={name} className="form-label mt-3">{label} {compulsory === true ? <span style={{ color: 'red', fontWeight: 'bold' }}> *</span> : null}</label>
      <input
        className={`form-control shadow-none ${meta.touched && meta.error ? 'is-invalid' : ''}`}
        name={name}
        value={field.value || ''}
        onChange={handleChange}
        onBlur={field.onBlur}
        placeholder={placeholder}
        autoComplete="new-password"
        inputMode="numeric"
      />
      <ErrorMessage component="div" name={name} className="error" />
    </div>
  );
};

export const PhoneField = (props) => <MaskedField {...props} maxDigits={10} formatter={formatPhone} />;
export const SsnField = (props) => <MaskedField {...props} maxDigits={9} formatter={formatSSN} />;
export const ZipField = (props) => <MaskedField {...props} maxDigits={5} />;

export default MaskedField;
